<template>
  <v-alert class="router-link py-0 px-2 rounded-0 inline-highlight mb-0 mr-2" dense :color="color" text outlined border="right">
    <v-row align="center" no-gutters class="py-0 my-0 shrink" @click="clickAction">
        <v-col class="shrink">
          <v-btn icon>
            <v-icon :color="color">{{icon}}</v-icon>
          </v-btn>
        </v-col>
        <v-col class="grow">
          <span class="subtitle-2 font-weight-medium">{{title}}</span>
        </v-col>
        <v-col class="shrink">
          <v-btn icon>
            <v-icon :color="color">{{rightIcon}}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
  </v-alert>
</template>
<script>
export default {
  name: 'highlight-button',
  props: {
    link: {
      type: String
    },
    type: {
      type: String,
      default: 'pending'
    },
    color: {
      type: String,
      default: 'pending'
    },
    icon: {
      type: String,
      default: 'mdi-account'
    },
    rightIcon: {
      type: String,
      default: 'mdi-chevron-right'
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    height: {
      type: Number,
      default: 60
    },
    onClick: {
      type: Function
    }
  },
  methods: {
    clickAction () {
      this.$emit('buttonAction')
    }
  }
}
</script>
<style lang="scss" type="text/scss">
.floating-button-avatar {
  position: absolute !important;

}

.inline-highlight {
  display: inline-block !important;
}

</style>
